import axios from "axios"
export default class ServicoSincronizacao {
  constructor() {
    this.urlServico = process.env.VUE_APP_URL_VOLUPIA + `/api/Sincronizacao`
  }
  getAll() {
    return axios({
      url: this.urlServico + `/GetAllSincronizacoesTable`,
      method: "GET"
    })
  }
  getTentativasByIdSincronizacao(id) {
    return axios({
      url: this.urlServico + `/GetTentativasByIdSincronizacao?id=${id}`,
      method: "GET"
    })
  }
  getSincronizacoesComFiltro(idFuncionario, tipoSincronizacao, dataInicio, dataFim) {
    return axios({
      url: this.urlServico + `/GetSincronizacoesComFiltro?idFuncionario=${idFuncionario}&tipoSincronizacao=${tipoSincronizacao}&dataInicio=${dataInicio}&dataFim=${dataFim}`,
      method: "GET"
    })
  }
}
